import { Card } from 'antd'
import LoeadMorePagination from 'components/elements/BaseInfinityScroll/LoeadMorePagination'
import { BlockLoader } from 'components/elements/Loader'
import { CallRow, TCall } from 'features/calls'
import { useLeadDetails } from 'features/leads/providers/LeadDetailsProvider'
import useFetchPageNew from 'hooks/useFetchpageNew'
import { FC } from 'react'
import { CallLogEmptyState } from './components/LeadTimelineEmptyStates'

const CallActivity: FC = () => {
 const { leadId, realtorId } = useLeadDetails()

 const { flatData, isLoading, fetchMore, hasMore, isRefetching, total } =
  useFetchPageNew<TCall>(`lead/profile/${leadId}`, {
   body: { type: 'voicecall', ...(realtorId ? { realtor_id: realtorId } : {}) },
   method: 'post',
   // enable: enabled,
  })

 if (isLoading) {
  return <BlockLoader />
 }

 if (!flatData || flatData.length === 0) {
  return <CallLogEmptyState />
 }

 return (
  <Card
   className="activity-layout-crd"
   title={`Call Log (${total})`}
   loading={isLoading}
   bodyStyle={{ flex: 1 }}
  >
   <div className="card-body-inner">
    <LoeadMorePagination
     fethMore={fetchMore}
     hasMore={hasMore}
     loading={isRefetching}
    >
     {flatData?.map((call) => (
      <CallRow key={call.id} call={call} leadId={leadId} />
     ))}
    </LoeadMorePagination>
   </div>
  </Card>
 )
}
export default CallActivity
